import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ToastService, ToastOptions, ToastPosition } from './toast.service';
import { ToastDirective } from './toast.directive';
import { NgClass } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { LucideAngularModule, X, CircleAlert, CircleCheck, Info } from 'lucide-angular';
import { HtmlUtils } from '@app/helpers/utils/html.utils';

@Component({
    selector: 'app-toast',
    standalone: true,
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ToastDirective, LucideAngularModule],
})
export class ToastComponent {
    protected toastService = inject(ToastService);
    private htmlUtils = inject(HtmlUtils);

    protected readonly X = X;
    protected readonly CircleAlert = CircleAlert;
    protected readonly CircleCheck = CircleCheck;
    protected readonly Info = Info;

    private toastsSignal = toSignal(this.toastService.toast$, {
        initialValue: [],
    });

    leftToasts = computed(() => this.toastsSignal().filter((toast) => toast.position === 'left'));

    centerToasts = computed(() => this.toastsSignal().filter((toast) => toast.position === 'center'));

    rightToasts = computed(() => this.toastsSignal().filter((toast) => toast.position === 'right'));

    trackById(_i: number, toast: ToastOptions) {
        return toast.id;
    }

    getContainerClasses(position: ToastPosition): string {
        const baseClasses = 'fixed top-4 z-50 flex flex-col gap-3 min-w-[320px] sm:max-w-[400px]';

        switch (position) {
            case 'left':
                return `${baseClasses} right-4 left-4`;
            case 'center':
                return `${baseClasses} left-1/2 transform -translate-x-1/2`;
            case 'right':

            default:
                return `${baseClasses} right-4`;
        }
    }
    setIcon(type: string) {
        switch (type) {
            case 'success':
                return this.CircleCheck;
            case 'error':
                return this.CircleAlert;
            case 'info':
                return this.Info;
            default:
                return this.CircleCheck;
        }
    }

    /**
     * Sanitizes HTML content to prevent XSS attacks while allowing safe HTML tags.
     */
    sanitizeHtml(content: string): SafeHtml {
        return this.htmlUtils.sanitizeForToast(content);
    }
}
